{
  "email": "E-mail",
  "showPassword": "Jelszó megjelenítése",
  "hidePassword": "Jelszó elrejtése",
  "welcomeText": "Rögzítse, elemezze és alakítsa át vállalatát napok – nem hónapok – alatt.",
  "certDicisTitle": "Tekintse meg megfelelőségi profilunkat",
  "certDicisAlt": "ISO 9001 + 27001 tanúsított vállalat (DICIS)",
  "certDsgvoAlt": "GDPR-kompatibilis – Európában tárolva",
  "certGobdAlt": "GoBD Ready",
  "dontHaveAccount": "Nincs fiókja",
  "contactCompany": "Kapcsolat a BLIKS IO-val",
  "loading": "Betöltés...",
  "byContinueTermFull": "A folytatással elfogadja a BLIKS IO <terms>Általános Szerződési Feltételeit</terms> és <privacy>Adatvédelmi Szabályzatát</privacy>.",
  "termOfService": "Általános Szerződési Feltételek",
  "privacyPolicy": "Adatvédelmi szabályzat",
  "termsLanguageFallbackNotice": "E licencfeltételek hivatalos változata német és angol nyelven elérhető. Az alábbiakban az angol nyelvű változat olvasható.",
  "backToLogin": "Vissza a bejelentkezéshez",
  "emailIsRequired": "Az e-mail cím megadása kötelező",
  "loggingOut": "Kijelentkezés folyamatban...",
  "switchingWorkspace": "Munkaterület váltása folyamatban...",
  "ssoSigningIn": "Bejelentkezés folyamatban...",
  "ssoSignInFailed": "Sikertelen bejelentkezés",
  "selectWorkspaceDescription": "Válassza ki, melyik munkaterületen szeretné folytatni",
  "selectWorkspaceCurrent": "Jelenlegi munkaterület",
  "selectWorkspacePending": "Meghívva",
  "noWorkspaceForEmail": "Ehhez az e-mail-címhez nem található munkaterület. Ellenőrizze a címet, vagy forduljon a rendszergazdájához."
}
